require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/common.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/common.legacy.js
// module id = 612
// module chunks = 31